module.exports = __webpack_public_path__ + "img/henkel.6ab6faaa.png";